import { render, staticRenderFns } from "./NavigationBeta.vue?vue&type=template&id=4bf46232&"
import script from "./NavigationBeta.vue?vue&type=script&lang=ts&"
export * from "./NavigationBeta.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationBeta.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports